module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"user_display_name":"<b>%{name}</b>様のレビューです。"}}')
  delete Component.options._Ctor
}
